import { render, staticRenderFns } from "./EodbOwnershipChange.vue?vue&type=template&id=6a7a25c1&scoped=true&"
import script from "./EodbOwnershipChange.vue?vue&type=script&lang=js&"
export * from "./EodbOwnershipChange.vue?vue&type=script&lang=js&"
import style0 from "./EodbOwnershipChange.vue?vue&type=style&index=0&id=6a7a25c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7a25c1",
  null
  
)

export default component.exports